import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

const GetUsersAccounts = urlConfig.GetUsersAccounts;
const DashboardCounts = urlConfig.DashboardCounts;
const GetPreworkDashboardDetails = urlConfig.GetPreworkDashboardDetails;
const GetDownStreamDetails = urlConfig.GetDownStreamDetails

export const getUserAccountsData = async (params: any) => {
  try {
    const response = await postCall(GetUsersAccounts, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getDashboardCounts = async (params: any) => {
  try {
    const response = await postCall(DashboardCounts, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getPreworkDashboardDetails = async (params: any) => {
  try {
    const response = await postCall(GetPreworkDashboardDetails, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getDownStreamDetails = async (params: any) => {
  try {
    const response = await postCall(GetDownStreamDetails, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};